import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private activeRequests = 0;
  private skipLoader = false;

  show(): void {
    if (!this.skipLoader) {
      this.activeRequests++;
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0) {
      this.loadingSubject.next(false);
    }
  }

  disableLoader(): void {
    this.skipLoader = true;
    this.activeRequests = 0;
    this.loadingSubject.next(false);
  }

  enableLoader(): void {
    this.skipLoader = false;
  }

  resetLoader(): void {
    this.activeRequests = 0;
    this.loadingSubject.next(false);
  }
}
